export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" aria-label="JL Security Hero">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ec2f58919dd3af14ca89ffacc502c844.jpg"
          alt="JL Security consultants providing risk assessment and compliance consultancy services in North Wales"
          title="Security Risk Compliance Consultancy North Wales"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="text-center max-w-5xl mx-auto">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight font-poppins">
            <a href="/" className="no-underline text-white">Security, Risk &amp; Compliance</a>
          </h1>
          <p className="text-xl sm:text-2xl text-white mb-8 leading-relaxed font-inter max-w-4xl mx-auto">
            <strong>JL Security</strong> helps organisations across <strong>North Wales</strong> and the UK reduce risk, meet compliance obligations and improve safety through practical consultancy, accredited training, technical systems and security operations
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center px-8 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer font-inter"
            >
              Get in Touch
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
            <a
              href="tel:+447834561015"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer font-inter"
            >
              <i className="ri-phone-line mr-2"></i>
              +44 7834 561015
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-3xl text-white"></i>
        </div>
      </div>
    </section>
  );
}
